var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlelectCollectionBgr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 613,
    viewBox: "0 0 354 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5922_48076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.224 603.266C346.836 607.584 347.117 613 347.117 613H6.936C6.936 613 7.14642 605.501 5.61902 602.739C4.09161 599.977 0 600.367 0 600.367V11.9797C0 11.9797 3.6702 12.2333 5.1976 9.47137C6.72501 6.70941 6.58734 0 6.58734 0H347.257C347.257 0 347.415 5.6571 348.943 8.41901C350.47 11.1809 354 11.9797 354 11.9797L354 600.367C354 600.367 351.612 598.947 349.224 603.266Z",
    fill: "#39346D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.879486 599.476V12.8386C1.25906 12.8079 1.73157 12.7437 2.24277 12.6136C3.47955 12.2991 5.04156 11.5708 5.96722 9.89697C6.41415 9.08881 6.71341 8.04761 6.92178 6.99744C7.13278 5.9342 7.2623 4.79938 7.3421 3.76782C7.42209 2.73407 7.45319 1.79053 7.46436 1.10583C7.46564 1.02692 7.46667 0.951355 7.46747 0.879456H346.421C346.423 0.914185 346.426 0.949829 346.428 0.986328C346.468 1.57318 346.537 2.38556 346.655 3.28802C346.887 5.05426 347.322 7.30585 348.173 8.8446C349.056 10.4409 350.493 11.4338 351.646 12.0193C352.216 12.3088 352.736 12.5084 353.121 12.6374L353.121 599.266C352.881 599.259 352.616 599.277 352.33 599.336C351.103 599.589 349.727 600.539 348.454 602.84C347.184 605.137 346.637 607.696 346.402 609.647C346.283 610.628 346.242 611.47 346.231 612.069C346.23 612.087 346.23 612.104 346.23 612.121H7.82529C7.82538 612.015 7.82516 611.901 7.82449 611.78C7.82028 611.023 7.79855 609.982 7.72806 608.851C7.65775 607.722 7.53806 606.49 7.33493 605.353C7.13501 604.234 6.84171 603.133 6.38864 602.314C5.44382 600.605 3.73563 599.926 2.41263 599.656C1.83557 599.538 1.30112 599.491 0.879486 599.476Z",
    stroke: "#B89B73",
    strokeWidth: 1.75896
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5922_48076",
    x: -8.79482,
    y: -8.79482,
    width: 371.59,
    height: 630.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.39741
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5922_48076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5922_48076",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlelectCollectionBgr);
export default __webpack_public_path__ + "static/media/slelectCollectionBgr.63e8337bc3d783e35d06b71f2b6663f1.svg";
export { ForwardRef as ReactComponent };